define('SageDotCom/Components/Videos/LiteVideo',[
    "jquery",
    "SageDotCom/Components/Videos/YoutubeVideo"
],
    /**
     * Youtube documentation reference https://developers.google.com/youtube/iframe_api_reference
     * Pay attention amending this file Video Listing Component has relation of it 
     */
    function ($, Youtube) {
        function LiteVideo(scope, stateChangeMessages, onPlayMessagesPerformer, onPauseMessagePerformer, playInModal, guid) {
            // Function to be called when the iframe is added
            function initializeTracking() {
                // Your tracking script code here
                var args = {};
                args.scope = scope;
                args.stateChange = stateChangeMessages;
                args.playMessage = onPlayMessagesPerformer;
                args.pauseMessage = onPauseMessagePerformer;
                args.playInModal = playInModal;
                args.guid = guid;
                Youtube.init(args);

                if (playInModal) {
                    //Handle modal showing as first click fallback
                    setTimeout(function () {
                        var $modalVideo = $(".modal", scope);
                        $modalVideo.modal("show");
                    }, 250);
                }
            }

            // Select all elements with the class 'youtube-video-section'
            const targetNode = $(".youtube-video-section", scope)[0];

            // Options for the observer (include the subtree so it observes all descendants)
            const observerConfig = { childList: true, subtree: true };

            // Callback function to execute when mutations are observed
            const callback = function (mutationsList, observer) {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        // Check if the added nodes are iframes
                        const addedNodes = mutation.addedNodes;
                        for (const node of addedNodes) {
                            if (node.tagName === 'IFRAME') {
                                // If an iframe is added, initialize tracking
                                initializeTracking();
                                // Disconnect the observer as it's no longer needed
                                observer.disconnect();
                                break;
                            }
                        }
                    }
                }
            };

            const observer = new MutationObserver(callback);
            observer.observe(targetNode, observerConfig);
        }

        return function initLiteVideo(args) {
            return args.IsExperienceEditorEditing
                ? null
                : new LiteVideo(args.scope,
                    args.stateChange || [],
                    args.playMessage || [],
                    args.pauseMessage || [],
                    args.playInModal || false,
                    args.guid);
        };
    });
